module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_maedori@3x-73c00548d07d377ea96767343bde9065.webp";